import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from 'react-tooltip-lite'
import ProgressBar from '../elements/ProgressBar'
import UnlimitedBar from '../elements/UnlimitedBar'
import { mapTidyUsageNames } from '../constants'
import ProgressBarSecurity from '../elements/ProgressBarSecurity'

const UsageRow = (props) => {
    const summaryText = () => {
        if (props.isUnlimitedUsage && props.itemKey !== 'others_and_excluded' && !props.showUnlimitedUsage) {
            return 'Unlimited'
        }

        if (typeof props.summaryText === 'object') {
            return props.summaryText
        }

        if (props.summaryText) {
            return props.summaryText.replace('/', ' / ')
        }
    }

    const hideOnMobile = props.isUnlimitedUsage && (props.itemKey !== 'data' && props.itemKey !== 'others_and_excluded') && !props.showUnlimitedUsage

    const Progress = () => {
        if (props.itemKey === 'security') {
            return <ProgressBarSecurity progress={props.progress} isDateField={props.isDateField} />
        }

        return <ProgressBar progress={props.progress} isDateField={props.isDateField} isDataBank={props.isDataBank} />
    }

    const title = mapTidyUsageNames[props.title] ? mapTidyUsageNames[props.title] : props.title

    return (
        <React.Fragment>
            {/* DESKTOP */}
            <div className='row my-1 font-small d-none d-lg-flex'>
                <div className='col-3 text-right truncate' dangerouslySetInnerHTML={{ __html: title }} title={title} />
                <div className='col-9 d-flex'>
                    {props.isUnlimitedUsage
                        ? <UnlimitedBar />
                        : <Tooltip content={`${props.progress}%`} className='w-100'>
                            {Progress()}
                          </Tooltip>}
                    <div className='ml-4 usage-row-min-width'>
                        {summaryText()}
                    </div>
                </div>
            </div>
            {/* MOBILE */}
            {hideOnMobile
                ? ''
                : <div className={`row d-lg-none ${props.isLastItem ? '' : 'mb-4'}`}>
                    <div className='col-12 bold mb-1' dangerouslySetInnerHTML={{ __html: mapTidyUsageNames[props.title] ? mapTidyUsageNames[props.title] : props.title }} />
                    {props.isUnlimitedUsage || props.itemKey === 'others_and_excluded'
                        ? ''
                        : <div className='col-12 mb-2 pr-3'>
                            {Progress()}
                          </div>}
                    <div className={props.isUnlimitedUsage ? 'col-12' : 'col-7 nowrap'}>
                        {summaryText()}
                    </div>
                    {!props.isUnlimitedUsage && !props.hideProgress
                        ? <div className='col-5 text-right'>
                            {props.progress}%{props.isDateField ? '' : ' used'}
                          </div>
                        : ''}
                  </div>}
        </React.Fragment>
    )
}

UsageRow.propTypes = {
    title: PropTypes.string.isRequired,
    isUnlimitedUsage: PropTypes.bool.isRequired,
    showUnlimitedUsage: PropTypes.bool,
    progress: PropTypes.number,
    summaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    itemKey: PropTypes.string,
    isDateField: PropTypes.bool,
    isLastItem: PropTypes.bool,
    isDataBank: PropTypes.bool,
    hideProgress: PropTypes.bool
}

export default UsageRow



// WEBPACK FOOTER //
// ./resources/js/components/UsageRow.js